module.exports = __webpack_public_path__ + "static/img/Nconsumed-one.79ca7b99.png";